import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignContentParams from './CampaignContentParams';

export type TagsInputValue = any[]

const mapStateToProps = (state, { t }) => {
  const campaignContentParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.campaign_content_params || [];
  const globalCampaignContentParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.campaign_content_params || []
  )
    .map(
      element => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalCampaignContentParams,
    ...campaignContentParams,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(CampaignContentParams));
